import { candidateMergeConfig } from "@/config/candidateMergeConfig";
import { companyMergeConfig } from "@/config/companyMergeConfig";
import { jobMergeConfig } from "@/config/jobMergeConfig";
import { matchMergeConfig } from "@/config/matchMergeConfig";
import { MergeFormConfig } from "@/types/merge";

/**
 * Central registry of all merge configurations
 * Maps entity names to their corresponding merge configurations
 */
const mergeConfigRegistry = {
	candidates: candidateMergeConfig,
	companies: companyMergeConfig,
	jobs: jobMergeConfig,
	matches: matchMergeConfig,
} as const;

/**
 * Type helper for supported entity names with merge configs
 */
export type SupportedMergeEntity = keyof typeof mergeConfigRegistry;

/**
 * Get merge configuration for a given entity name
 */
export function getMergeConfig(entityName: string): MergeFormConfig<any> | null {
	return mergeConfigRegistry[entityName as SupportedMergeEntity] || null;
}

/**
 * Check if an entity has a merge configuration
 */
export function hasMergeConfig(entityName: string): entityName is SupportedMergeEntity {
	return entityName in mergeConfigRegistry;
}
